<template>
    <div class="listmain ">
         <h1 class="firTitle">会话设计</h1>
              <p>会话相关内容,通过该字段可以灵活的控制skill会话的保持与退出
              </p>

              <h5 class="thirdTitle">请求头信息：</h5>
              <p>POST : /intent/invoke HTTP/1.1
                <br>Content-Type : application/x-www-form-urlencoded;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br>Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>

              <h5 class="codeTitle">会话设计</h5>
              <highlight-code lang="javascript">
                { //Type:JSONObject,会话相关内容,通过该字段可以灵活的控制skill会话的保持与退出
            "type": "SkillSession.Begin //Type:String,开始 SkillSession.Running //运行 SkillSession.End //结束 SkillSession.Invalid //无效"
            "attributes":{//Type:JSONObject,会话属性，会话结束后自动清空，用户会话未结束，再生命周期中会持续保持该属性
                "a":"b",//Type:String
                "c":"d"//Type:String
            },
            "context":"normal"//Type:String,上下文场景，normal，voiceprintPay
  }


             </highlight-code>
             <h5 class="codeTitle">会话状态参数说明： </h5>
               <p>技能会话包含四种状态：SkillSession.Begin（开始），SkillSeesion.Runing（运行），SkillSession.End（结束），SkillSession.Invalid（无效）
                <br>如果一个技能需要接收通用指令（上一首、下一首、是、否等）需要进行会话状态的配置，如果不需要接收通用指令则每次的请求都是技能会话的结束。
                <br>天气，典型的单轮技能，会话状态为：
                <br>{"type":"SkillSession.End"}
                <br> 音乐，喜马拉雅，情商，典型的多轮技能，点播开始或技能开始：
                <br>{ "type":"SkillSession.Begin/SkillSession.Running"}
                  <br> 会话状态中，如果技能需要与客户端进行数据交互（例如播放时长上报等），这种情况下技能的会话即不能变为结束
                <br>状态也不能变为运行状态，需要指定为无效状态：
                  <br> {"type":"SkillSession.Invalid"}
                <br>无效状态上层中控系统不会对技能所处的状态进行任何操作！！！
                  <br> 用户进行下一首操作：
                <br>{"type":"SkillSession.Running"}
                  <br> 当前技能会话结束（播放完最后一首歌曲，技能学习完毕），不需要再接收通用的指令则相应状态为：
                <br>{ "type":"SkillSession.End"}

              </p>


    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 26px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/zdyjn_hhsj.vue